import React from "react";
import KpiSection from "./sections/KpiSection";
import TablesSection from "./sections/TablesSection";
import TrendSection from "./sections/TrendSection";
import FinancialSection from "./sections/FinancialSection";

const DashboardBody = ({
  loading,
  errorMessage,
  filteredVisits,
  insights,
  customerVisitSearch,
  setCustomerVisitSearch,
  filteredCustomerVisitRows,
}) => {
  if (loading) {
    return (
      <div className="dashboard-panel mt-3">
        <div className="d-flex align-items-center gap-2">
          <div className="spinner-border text-info" aria-hidden="true" />
          <span>Loading dashboard insights...</span>
        </div>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="dashboard-panel mt-3">
        <div className="text-danger fw-semibold">{errorMessage}</div>
      </div>
    );
  }

  return (
    <>
      {filteredVisits.length === 0 && (
        <div className="dashboard-panel mt-3">
          <div className="empty-panel">
            No visits found for selected filters. Try changing the range.
          </div>
        </div>
      )}

      <KpiSection insights={insights} />
      <TablesSection
        filteredVisits={filteredVisits}
        customerVisitSearch={customerVisitSearch}
        setCustomerVisitSearch={setCustomerVisitSearch}
        filteredCustomerVisitRows={filteredCustomerVisitRows}
      />
      <TrendSection insights={insights} />
      <FinancialSection insights={insights} />
    </>
  );
};

export default DashboardBody;
